import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import Search from '../../shared/components/ui/Search';
import Button from '../../shared/components/ui/Button';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import LiveFeedCard from './LiveFeedCard';
import { CreatePost } from '../components/forms/CreatePost';
import Modal from '../../shared/components/ui/Modal';
import { getPosts } from '../services/api/implementation/impl';
import { useQuery } from '@tanstack/react-query';
import socket from '../../../socket';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  buildReturnToFromLocation,
  navigateWithReturn
} from '../../shared/navigation';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import Loader from '../../shared/components/ui/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';

const LiveFeedList = () => {
  const userId = Cookies.get('userId');
  const [isCreatePost, setisCreatePost] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { collapsed } = useSidebar();
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [limit] = useState(50);
  const [allPosts, setAllPosts] = useState([]);

  const {
    data: posts,
    refetch: refetchPosts,
    isFetching
  } = useQuery({
    queryKey: ['posts', page],
    queryFn: () => getPosts(page, limit)
  });

  socket.on('Post', () => {
    setPage(1);
    setAllPosts([]);
    setHasMore(true);
    refetchPosts();
  });

  // Track page view
  useEffect(() => {
    mixpanel.track('Live Feed List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (posts) {
      if (page === 1) {
        // First page or refresh - replace all posts
        setAllPosts(posts);
      } else {
        // Subsequent pages - append to existing posts
        setAllPosts((prev) => [...prev, ...posts]);
      }

      // Check if we have more data to load
      setHasMore(posts.length === limit);
    }
  }, [posts, page, limit]);

  const handleOnCreatePost = () => {
    setisCreatePost(!isCreatePost);
  };

  const onPostCreate = () => {
    setisCreatePost(false);
    setPage(1);
    setAllPosts([]);
    setHasMore(true);
    refetchPosts();
  };

  const loadMore = () => {
    if (!isFetching && hasMore) {
      setPage((prev) => prev + 1);
    }
  };
  useEffect(() => {
    if (isCreatePost) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isCreatePost]);

  // useEffect(() => {
  //   if (isOpen) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = '';
  //   }

  //   return () => {
  //     document.body.style.overflow = '';
  //   };
  // }, [isOpen]);

  return (
    <>
      <Loader isVisible={isFetching} />
      {/* Create Post Modal */}
      {isCreatePost && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Create New Post'}
          width={80}
          onClose={() => setisCreatePost(!isCreatePost)}>
          <CreatePost onSuccess={onPostCreate} onClose={() => setisCreatePost(!isCreatePost)} />
        </Modal>
      )}

      <Layout>
        {/* Header */}
        <div
          className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <Header data={{ name: `Live Feed` }} />
        </div>
        {/* Main content */}
        <div
          className={`flex items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 shadow-sm z-[10] transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          } mt-[0rem]`}>
          <Search />
          <div className="flex gap-5 cursor-pointer">
            <Button children={'New Post'} onClick={handleOnCreatePost} />
          </div>
        </div>
        <GridWrapper>
          {/* Check if posts exist */}
          <InfiniteScroll
            dataLength={allPosts.length}
            next={loadMore}
            hasMore={hasMore}
            loader={
              <div className="flex justify-center items-center py-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <span className="ml-2 text-gray-600">Loading more posts...</span>
              </div>
            }
            endMessage={
              <div className="flex justify-center items-center py-4">
                <p className="text-gray-500">No more posts to load</p>
              </div>
            }
            style={{ overflow: 'visible' }}>
            <div className="flex flex-col gap-8 mt-[11rem]">
              {allPosts && allPosts?.length > 0 ? (
                allPosts?.map((post) => (
                  <div
                    key={post.id}
                    onClick={() => {
                      setIsOpen(!isOpen);
                      navigateWithReturn(navigate, `/builder/post/${post.id}`, {
                        returnTo: buildReturnToFromLocation(location)
                      });
                    }}>
                    <LiveFeedCard
                      data={post}
                      onSuccess={() => {
                        setPage(1);
                        setAllPosts([]);
                        setHasMore(true);
                        refetchPosts();
                      }}
                    />
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500">No posts to show</p>
              )}{' '}
            </div>
          </InfiniteScroll>
        </GridWrapper>
      </Layout>
    </>
  );
};

export default LiveFeedList;
